
import React, { Suspense } from 'react';
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

// styles for this kit
import "assets/css/bootstrap.min.css";
import "assets/scss/now-ui-kit.scss";
import "assets/demo/demo.css";
import "assets/demo/nucleo-icons-page-styles.css";
import "assets/css/custom.css";
import "assets/css/redesign.css";

import 'views/examples/i18n.js';

// redesign pages
import Home from 'views/redesign/Home.js';
import UeberUns from 'views/redesign/UeberUns.js';
import Geschichte from 'views/redesign/Geschichte.js';
import Standorte from 'views/redesign/Standorte.js';
import FuerUnternehmen from 'views/redesign/FuerUnternehmen.js';
import Faq from 'views/redesign/Faq.js';
import Live from 'views/redesign/Live.js';
import UnserHonig from 'views/redesign/UnserHonig.js';
import Warenkorb from 'views/redesign/Warenkorb.js';
import Impressum from 'views/redesign/Impressum.js';
import Datenschutz from 'views/redesign/Datenschutz.js';
import GAPageView from 'components/Redesign/GAPageView.js';

// shop (Cart/Recipe-Innereien unverändert, Chrome + Sortiment-Darstellung neu)
import cartReducer from 'views/examples/Shop/cartReducer';
import { Provider } from 'react-redux';
import { createStore } from 'redux';



// loading component for suspense fallback
const Loader = () => (
    <div>loading...</div>
);

const store = createStore(cartReducer)



ReactDOM.render(
<Suspense fallback={<Loader />}>
  <Provider store={store}>
    <BrowserRouter>
      <GAPageView />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/ueber-uns" component={UeberUns} />
        <Route path="/ueber-uns/unsere-geschichte" component={Geschichte} />
        <Route path="/ueber-uns/unsere-standorte" component={Standorte} />
        <Route path="/fuer-unternehmen" component={FuerUnternehmen} />
        <Route path="/live" component={Live} />
        <Route path="/faq" component={Faq} />
        <Route path="/unser-honig" component={UnserHonig} />
        <Route path="/warenkorb" component={Warenkorb} />
        <Route path="/impressum" component={Impressum} />
        <Route path="/datenschutz" component={Datenschutz} />
        <Redirect from="/index" to="/" />
        <Redirect from="/home" to="/" />
        <Redirect from="/our-bees" to="/live" />
        <Redirect from="/kontakt" to="/faq" />
        <Redirect from="/shop" to="/unser-honig" />
        <Redirect to="/" />
      </Switch>
    </BrowserRouter>
  </Provider>
</Suspense>,

 document.getElementById('root')
);
